var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C10.5939 0.5 13.5 3.40614 13.5 7C13.5 8.21133 13.0936 9.6058 12.4502 11.042C11.8097 12.4716 10.9515 13.9066 10.0859 15.1895C9.22135 16.4709 8.35488 17.591 7.70508 18.3916C7.42337 18.7387 7.18198 19.0246 7 19.2373C6.81802 19.0246 6.57663 18.7387 6.29492 18.3916C5.64512 17.591 4.77865 16.4709 3.91406 15.1895C3.04854 13.9066 2.19028 12.4716 1.5498 11.042C0.906389 9.6058 0.5 8.21133 0.5 7C0.5 3.40614 3.40614 0.5 7 0.5ZM7 1.5C3.96386 1.5 1.5 3.96386 1.5 7C1.5 8.5619 2.28788 10.4614 3.2832 12.251C4.28999 14.0611 5.55636 15.8408 6.60547 17.1875L6.99805 17.6904L7.39258 17.1895C8.46258 15.8318 9.73013 14.0588 10.7324 12.2539C11.7239 10.4684 12.5 8.57543 12.5 7C12.5 3.96386 10.0361 1.5 7 1.5ZM7 5C8.10457 5 9 5.89543 9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5Z",
    fill: "#FD9D03",
    stroke: "#FD9D03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.152e981a26bcdc0b6494bf8e537e28b2.svg";
export { ForwardRef as ReactComponent };